import type { ConfigTags, TagRow } from '../../types'

// Collect the editable key/value rows into a tags object. Keys and values are
// both trimmed and rows with an empty key are dropped; tags are optional, so
// zero rows is valid. Values are trimmed to match collectPairs (the tag filter),
// so a saved value never fails to match the trimmed value the filter queries by.
export function collectTags(rows: TagRow[]): ConfigTags {
  return rows.reduce<ConfigTags>((tags, { key, value }) => {
    const trimmedKey = key.trim()
    if (!trimmedKey) {
      return tags
    }
    return { ...tags, [trimmedKey]: value.trim() }
  }, {})
}
